import { paginatedQuery } from 'lib-shared-api-utils';
import { api } from 'utils/apis/api';
export const companiesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createCompany: builder.mutation({
            query: (data) => ({
                version: 1,
                path: 'companies',
                method: 'POST',
                data,
            }),
        }),
        readCompany: builder.query({
            query: ({ id }) => ({
                version: 1,
                path: `companies/${id}`,
            }),
        }),
        readCompanyRelatedUsers: builder.query({
            query: (arg) => paginatedQuery(arg, ({ id }) => ({
                version: 1,
                path: `companies/${id}/users`,
            })),
        }),
        updateCompany: builder.mutation({
            query: ({ id, patch: body }) => ({
                version: 1,
                path: `companies/${id}`,
                method: 'PATCH',
                body,
            }),
        }),
        readCompanies: builder.query({
            query: ({ limit }) => ({
                version: 1,
                path: 'companies',
                params: {
                    limit,
                },
            }),
        }),
    }),
});
